import { Modal } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import ToPickerMultiBoxLoop from "../../../../../components/TOPickerMultiBoxLoop/ToPickerMultiBoxLoop";

export class PickerMedPickingModal extends Component {
  render() {
    let { medPickingModal, toggleMedPickingModal } = this.props;
    return (
      <div>
        <Modal
          title="Pick Medicine"
          open={medPickingModal}
          centered
          onCancel={() => toggleMedPickingModal(false)}
          className="medPickingModal"
          footer={null}
        >
          <ToPickerMultiBoxLoop
            pageLoadToggle={this.props.pageLoadToggle}
            access_token={this.props.access_token}
            boxNumber={this.props.boxNumber}
            medName={this.props.medName}
            productCode={this.props.productCode}
            currentQty={this.props.currentQty}
            nextMedicine={() => this.props.nextMedicine()}
            handleLastMed={() => this.props.handleLastMed()}
            pendingQuantity={this.props.pendingQuantity}
            toNumber={this.props.toNumber}
            updateBoxNumber={(value) => {
              this.props.updateBoxNumber(value);
            }}
          />
        </Modal>
      </div>
    );
  }
}
export default PickerMedPickingModal;
